import { EP_CHANGE_JOIN_APPROVAL, EP_CHANGE_NAME, EP_CHANGE_SETTING, EP_DECLARE, EP_DISCARD, EP_GROUP_CARDS, EP_PICK_DECK_CARD, EP_PICK_DISCARDED_CARD, EP_READY, EP_REQUEST_SWAP, EP_RESPONSE_SWAP, EP_SHOW_WINNING_CARDS, EP_START } from '../constants/endPointConstants';
import api from './Api';
import { formatStringPlaceholder } from './CommonService';

const startGame = async (roomId, playerId) => {
    const response = await api.post(`${formatStringPlaceholder(EP_START, {roomId: roomId, playerId: playerId})}`);
    return response.data;
}

const readyGame = async (roomId, playerId) => {
    const response = await api.post(`${formatStringPlaceholder(EP_READY, {roomId: roomId, playerId: playerId})}`);
    return response.data;
}

const pickDeckCard = async (roomId, playerId, cardsInHand) => {
    const response = await api.post(`${formatStringPlaceholder(EP_PICK_DECK_CARD, {roomId: roomId, playerId: playerId})}`, cardsInHand);
    return response.data;
}

const pickDiscardedCard = async (roomId, playerId, mustDeclareWinner, cardsInHand) => {
    const response = await api.post(`${formatStringPlaceholder(EP_PICK_DISCARDED_CARD, {roomId: roomId, playerId: playerId})}`, cardsInHand,
        {params: {mustDeclareWinner: mustDeclareWinner}});
    return response.data;
}

const discard = async (roomId, playerId, cardId, cardsInHand, pairCardId) => {
    const response = await api.post(`${formatStringPlaceholder(EP_DISCARD, {roomId: roomId, playerId: playerId, cardId: cardId, pairCardId: pairCardId})}`, 
    cardsInHand, {params: {pairCardId: pairCardId ?? null}});
    return response.data;
}

const declareWinner = async (roomId, playerId, cardId) => {
    const response = await api.post(`${formatStringPlaceholder(EP_DECLARE, {roomId: roomId, playerId: playerId, cardId: cardId})}`);
    return response.data;
}

const showWinningCard = async (roomId, playerId, winningCards) => {
    const response = await api.post(`${formatStringPlaceholder(EP_SHOW_WINNING_CARDS, { roomId: roomId, playerId: playerId})}`, // Route with placeholders
        winningCards // Body parameter
    );
    return response.data;
};

const groupCards = async (roomId, playerId, groupedCards) => {
    const response = await api.post(`${formatStringPlaceholder(EP_GROUP_CARDS, { roomId: roomId, playerId: playerId})}`, // Route with placeholders
    groupedCards // Body parameter
    );
    return response.data;
};

const changeSetting = async (roomId, playerId, deckCount, jokerPairs, settings = {}) => {
    const response = await api.post(`${formatStringPlaceholder(EP_CHANGE_SETTING, {roomId: roomId, playerId: playerId, deckCount: deckCount, jokerPairs: jokerPairs})}`, settings);
    return response.data;
}

const changeJoinApproval = async (roomId, playerId, autoApprove) => {
    const response = await api.post(formatStringPlaceholder(EP_CHANGE_JOIN_APPROVAL, { roomId, playerId }), null,
        { params: { autoApprove } });
    return response.data;
}

const changeName = async (roomId, playerId, name) => {
    const response = await api.post(`${formatStringPlaceholder(EP_CHANGE_NAME, {roomId: roomId, playerId: playerId, name: name})}`);
    return response.data;
}
const requestSwap = async (roomId, playerId, targetPlayerId) => {
    const response = await api.post(`${formatStringPlaceholder(EP_REQUEST_SWAP, {roomId: roomId, playerId: playerId, targetPlayerId: targetPlayerId})}`);
    return response.data;
}
const responseSwap = async (roomId, playerId, requestPlayerId, isAccept = false) => {
    // const isAccept = paramIsAccess ? 1 : 0;
    const response = await api.post(`${formatStringPlaceholder(EP_RESPONSE_SWAP, {roomId: roomId, playerId: playerId, requestPlayerId: requestPlayerId, isAccept: isAccept.toString()})}`);
    return response.data;
}

export {startGame, readyGame, pickDeckCard, pickDiscardedCard, discard, declareWinner, showWinningCard, groupCards, changeSetting, changeJoinApproval, changeName, requestSwap, responseSwap}
